
import { MultiDocumentEdit } from './MultiDocumentEdit';
import { SingleDocumentEdit } from './SingleDocumentEdit';
export type FileEditProps = {
    documentIds: string[],
    onSuccess?: () => void,
    onCancel?: () => void,
}

export function FileEdit(props: FileEditProps) {

    const { documentIds } = props;
    //TODO Add fields based on OData schema

    if (documentIds.length === 1)
        return <SingleDocumentEdit documentId={documentIds[0]} {...props} />

    return <>
        <MultiDocumentEdit documentIds={documentIds} {...props} />
    </>
}